import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BookOpen, Users, FileText, Target, Video, Globe2, Map, Layers, Mountain, Waves, Cloud, ArrowRight, Compass, TreePine, GraduationCap, Award } from 'lucide-react';
import axios from 'axios';
import { useSiteContent } from '../contexts/SiteContentContext';

const API = process.env.REACT_APP_BACKEND_URL;
const B = `${API}/api/files/dersimizcografiya/uploads`;
const LOCAL = {
  volcano: `${B}/af46362f-3e81-4e09-89e3-5da894bd82b9.jpg`,
  mountain: `${B}/47ef7813-7734-4f04-bad2-41faed93bdbd.jpg`,
  ocean: `${B}/6c1e8512-f1b6-40d6-8b84-3c9e14379c1a.jpg`,
  desert: `${B}/8323a863-2eaa-456c-8e55-ee3c07bfd141.jpg`,
  river: `${B}/ef2756c6-5b2c-4b74-a57a-2a8e9f5b7a0c.jpg`,
  aurora: `${B}/7b1de8e6-cf40-4f99-be57-48941bc4ef9a.jpg`,
  globe: `${B}/f959a2d9-7cfe-459c-b0bf-42d8f29bae91.jpg`,
};

const iconMap = { BookOpen, Users, FileText, Target, Video, Globe2, Map, Layers, Mountain, Waves, Cloud, Compass, TreePine, GraduationCap, Award };

export default function Services() {
  const content = useSiteContent();
  
  const c = content || {};

  if (!content) return <div className="min-h-screen flex items-center justify-center bg-[#F4F7F6]"><div className="w-10 h-10 border-4 border-[#0077B6] border-t-transparent rounded-full animate-spin" /></div>;

  const pg = c.services_page || {};
  // Hero
  const heroBadge = pg.hero_badge || 'Xidmətlərimiz';
  const heroTitle = pg.hero_title || 'Xidmətlərimiz';
  const heroSubtitle = pg.hero_subtitle || 'Vulkanlardan buzlaqlara, okeandan atmosferə — coğrafiyanın hər sahəsində peşəkar xidmət';
  const heroBg = pg.hero_bg || LOCAL.volcano;
  // Services
  const svcBadge = pg.svc_badge || 'Təhsil Xidmətləri';
  const svcTitle = pg.svc_title || 'Necə Öyrədirik?';
  const svcSubtitle = pg.svc_subtitle || 'Hər şagirdin ehtiyacına uyğun peşəkar yanaşma';
  const defSvc = [
    {icon:'BookOpen',title:'Fərdi Dərslər',desc:'Hər şagirdin səviyyəsinə uyğun fərdi dərs planı.',image:LOCAL.mountain},
    {icon:'Users',title:'Qrup Dərsləri',desc:'3-5 nəfərlik kiçik qruplarda interaktiv dərslər.',image:LOCAL.river},
    {icon:'FileText',title:'Dərs Vəsaitləri',desc:'PDF dərs qeydləri, sxemlər, xəritələr və köməkçi materiallar.',image:LOCAL.desert},
    {icon:'Video',title:'Video Dərslər',desc:'Mövzuların ətraflı video izahları. İstədiyiniz vaxt öyrənin.',image:LOCAL.ocean},
  ];
  const svcItems = pg.services || defSvc;
  // Subjects
  const subBadge = pg.sub_badge || 'Fənn Sahələri';
  const subTitle = pg.sub_title || 'Coğrafiya Sahələri';
  const subSubtitle = pg.sub_subtitle || 'Hər sahədə dərin bilik və praktiki təcrübə';
  const subBg = pg.sub_bg || LOCAL.ocean;
  const defSub = [
    {icon:'Globe2',title:'Fiziki Coğrafiya',desc:'Yer kürəsinin quruluşu, iqlim, relyef, su ehtiyatları.',image:LOCAL.mountain},
    {icon:'Map',title:'İqtisadi Coğrafiya',desc:'Dünya ölkələri, əhali, təsərrüfat və beynəlxalq əlaqələr.',image:LOCAL.desert},
    {icon:'Layers',title:'Xəritəşünaslıq',desc:'Xəritə oxuma, koordinat sistemi, miqyas.',image:LOCAL.globe},
    {icon:'Mountain',title:'Geomorfologiya',desc:'Dağlar, düzənliklər, vulkanlar və yer səthinin formalaşması.',image:LOCAL.aurora},
    {icon:'Waves',title:'Okeanologiya',desc:'Okean və dənizlər, su axınları, gel-git.',image:LOCAL.ocean},
    {icon:'Target',title:'İmtahana Hazırlıq',desc:'Buraxılış və qəbul imtahanlarına hərtərəfli hazırlıq.',image:LOCAL.river},
  ];
  const subItems = pg.subjects || defSub;
  // Parallax
  const parBg = pg.parallax_bg || LOCAL.aurora;
  const parTitle = pg.parallax_title || 'Atmosferdən Kainata';
  const parSubtitle = pg.parallax_subtitle || 'Yer kürəsinin hər qatını, hər prosesini birlikdə kəşf edəcəyik';
  // CTA
  const ctaTitle = pg.cta_title || 'Sualınız Var?';
  const ctaSubtitle = pg.cta_subtitle || 'Bizimlə əlaqə saxlayın və coğrafiya təhsiliniz haqqında məlumat alın';
  const ctaBtnText = pg.cta_btn_text || 'Bizimlə Əlaqə';
  const ctaBtnUrl = pg.cta_btn_url || '/contact';
  // Our Services (new section)
  const ourSvcTitle = pg.our_svc_title || 'Bizim Xidmətlərimiz';
  const defOurSvc = [
    {icon:'GraduationCap',title:'Abituriyent hazırlığı',desc:'8, 9, 10 və 11-ci siniflərin ali təhsil müəssisələrinə hazırlığı',url:'/contact'},
    {icon:'BookOpen',title:'MİQ hazırlığı',desc:'Müəllimlərin işə qəbulu üzrə müsabiqəyə hazırlıq',url:'/contact'},
    {icon:'Award',title:'Sertifikasiya hazırlığı',desc:'Müəllimlərin sertifikasiya imtahanına hazırlıq',url:'/contact'},
  ];
  const ourSvcItems = (pg.our_services || []).map((item, i) => ({
    icon: item.icon || defOurSvc[i]?.icon || 'BookOpen',
    title: item.title || defOurSvc[i]?.title || '',
    desc: item.desc || defOurSvc[i]?.desc || '',
    url: item.url || defOurSvc[i]?.url || '/contact',
  }));
  if (ourSvcItems.length === 0) ourSvcItems.push(...defOurSvc);

  const svcIcons = [BookOpen, Users, FileText, Video];
  const subColors = ['from-[#0077B6] to-[#00B4D8]','from-[#03045E] to-[#0077B6]','from-[#00B4D8] to-[#48CAE4]','from-[#0077B6] to-[#03045E]','from-[#03045E] to-[#00B4D8]','from-[#00B4D8] to-[#0077B6]'];

  return (
    <div>
      {/* Hero */}
      <section className="relative py-28 md:py-36 overflow-hidden">
        <div className="absolute inset-0"><img src={heroBg} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-gradient-to-t from-[#03045E]/40 to-transparent" /></div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white text-sm font-bold mb-6 border border-white/20"><Compass className="w-4 h-4" /> {heroBadge}</span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">{heroTitle}</h1>
            <p className="text-lg md:text-xl text-white font-semibold max-w-2xl mx-auto">{heroSubtitle}</p>
          </motion.div>
        </div>
      </section>

      {/* Our Services - New Section */}
      <section className="py-20 bg-[#F4F7F6] relative overflow-hidden">
        <div className="absolute -right-32 -top-32 w-80 h-80 rounded-full bg-[#0077B6]/5" />
        <div className="absolute -left-20 -bottom-20 w-60 h-60 rounded-full bg-[#00B4D8]/5" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="text-center mb-14">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2530]">{ourSvcTitle}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {ourSvcItems.map((item, i) => {
              const Icon = iconMap[item.icon] || BookOpen;
              return (
                <motion.div key={i}
                  className="relative bg-white rounded-3xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 group border border-[#E2E8F0] overflow-hidden flex flex-col"
                  initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0077B6] to-[#00B4D8] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#0077B6] to-[#00B4D8] flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1A2530] mb-3 line-clamp-1 min-h-[1.75rem]">{item.title}</h3>
                  <p className="text-sm text-[#5C6B7A] leading-relaxed mb-5 line-clamp-2 min-h-[2.5rem]">{item.desc}</p>
                  <div className="mt-auto">
                    <Link to={item.url || `/service/${i}`} className="inline-flex items-center gap-1.5 text-sm font-bold text-[#0077B6] group-hover:gap-3 transition-all">
                      Ətraflı <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-24 md:py-32 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 rounded-full bg-[#0077B6]/10 text-[#0077B6] text-sm font-bold mb-4 border border-[#0077B6]/20">{svcBadge}</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2530] mb-4">{svcTitle}</h2>
            <p className="text-lg text-[#5C6B7A] font-semibold max-w-2xl mx-auto">{svcSubtitle}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {svcItems.map((s, i) => {
              const Icon = iconMap[s.icon] || svcIcons[i] || BookOpen;
              return (
                <motion.div key={i} className="group flex gap-6 bg-[#F4F7F6] rounded-3xl p-6 hover:shadow-xl transition-all duration-500 border border-transparent hover:border-[#0077B6]/10"
                  initial={{ opacity: 0, x: i % 2 === 0 ? -20 : 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                  <div className="w-28 h-28 rounded-2xl overflow-hidden flex-shrink-0 shadow-md">
                    <img src={s.image || LOCAL.mountain} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#0077B6] to-[#00B4D8] flex items-center justify-center"><Icon className="w-4 h-4 text-white" /></div>
                      <h3 className="text-lg font-bold text-[#1A2530]">{s.title}</h3>
                    </div>
                    <p className="text-sm text-[#5C6B7A] leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Subject Areas */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-slate-800/80 via-[#03045E]/70 to-slate-800/80 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10"><img src={subBg} alt="" className="w-full h-full object-cover" /></div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 rounded-full bg-white/10 text-white text-sm font-bold mb-4 border border-white/20">{subBadge}</span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">{subTitle}</h2>
            <p className="text-lg text-white font-semibold max-w-2xl mx-auto">{subSubtitle}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {subItems.map((sub, i) => {
              const Icon = iconMap[sub.icon] || Globe2;
              return (
                <motion.div key={i} className="group relative overflow-hidden rounded-3xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500"
                  initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}>
                  <div className="relative h-48 overflow-hidden">
                    <img src={sub.image || LOCAL.mountain} alt={sub.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                    <div className={`absolute inset-0 bg-gradient-to-t ${subColors[i] || subColors[0]} opacity-30`} />
                    <div className="absolute top-4 right-4 p-3 rounded-2xl bg-white/20 backdrop-blur-sm"><Icon className="w-6 h-6 text-white" /></div>
                    <div className="absolute bottom-4 left-6"><h3 className="text-xl font-bold text-white">{sub.title}</h3></div>
                  </div>
                  <div className="p-6"><p className="text-sm text-[#5C6B7A] leading-relaxed">{sub.desc}</p></div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Parallax break */}
      <section className="relative h-72 overflow-hidden">
        <div className="absolute inset-0"><img src={parBg} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-[#03045E]/30" /></div>
        <div className="relative z-10 flex items-center justify-center h-full text-center px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Cloud className="w-12 h-12 text-white/50 mx-auto mb-4" />
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-2">{parTitle}</h3>
            <p className="text-white/70 max-w-lg mx-auto">{parSubtitle}</p>
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-white relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Globe2 className="w-12 h-12 text-[#0077B6]/30 mx-auto mb-6" />
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2530] mb-6">{ctaTitle}</h2>
            <p className="text-lg text-[#5C6B7A] font-semibold max-w-xl mx-auto mb-8">{ctaSubtitle}</p>
            <Link to={ctaBtnUrl} className="inline-flex items-center gap-2 px-8 py-4 rounded-2xl bg-gradient-to-r from-[#0077B6] to-[#00B4D8] text-white font-bold hover:shadow-lg transition-all group">
              {ctaBtnText} <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
